/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2TaskMovedIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2TaskMovedIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2TaskMovedIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 14,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2TaskMovedIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 14 14"
 style={{'--as-1-2t125S': alignSelf,'--mt-2-2t125S': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-2t125S': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-2t125S': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-2t125S': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-2t125S': opacity,'--w-10-2t125S': typeof width === 'number' ? `${width}px` : width,'--h-11-2t125S': typeof height === 'number' ? `${height}px` : height,'--f-12-2t125S': fill,'--a-7-2t125S': isAnimated ? animation : "none",'--sd-8-2t125S': isAnimated ? strokeDashoffset : 0,'--sd-9-2t125S': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2TaskMovedIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M14 .75a.75.75 0 00-1.5 0v12.5a.75.75 0 101.5 0V.75zM0 5.25a1.5 1.5 0 011.5-1.5H5a1.5 1.5 0 011.5 1.5v1h2V5a.5.5 0 01.853-.354l2 2a.5.5 0 010 .708l-2 2A.5.5 0 018.499 9V7.75h-2v1a1.5 1.5 0 01-1.5 1.5H1.5A1.5 1.5 0 010 8.75v-3.5z"
 style={{'--f-12-2t125S': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}